module.exports = __webpack_public_path__ + "static/media/qr-google-play.1ac65812.png";